export default {"src":"/_next/static/media/lightning-green.3a1147cd.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};